"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var useStyles = function useStyles(templateName, style) {
  return {
    desktop: style.hasOwnProperty("template-".concat(templateName, "[desktop]")) ? style["template-".concat(templateName, "[desktop]")] : '',
    tablet: style.hasOwnProperty("template-".concat(templateName, "[tablet]")) ? style["template-".concat(templateName, "[tablet]")] : '',
    mobile: style.hasOwnProperty("template-".concat(templateName, "[mobile]")) ? style["template-".concat(templateName, "[mobile]")] : ''
  };
};

exports.useStyles = useStyles;